import { render } from "./ApplicationFormView.vue?vue&type=template&id=05cfaca9&scoped=true"
import script from "./ApplicationFormView.vue?vue&type=script&lang=js"
export * from "./ApplicationFormView.vue?vue&type=script&lang=js"

import "./ApplicationFormView.vue?vue&type=style&index=0&id=05cfaca9&scoped=true&lang=scss"

import exportComponent from "/home/timecard-prod/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cfaca9"]])

export default __exports__